import axios from 'axios';

// 创建一个axios实例
const instance = axios.create({
  timeout: 10000, // 设置超时时间
  headers: {
    'Content-Type': 'application/json', // 设置请求头
  },
});

// 封装请求函数
export const request = async (url, method = 'POST', data = null) => {
  try {
    const response = await instance({
      method,
      url:`/api${url}`,
      data,
    });
    return response.data;
  } catch (error) {
    this.$message({
        message: "操作失败，请稍后再试",
        type: "error",
    });
    // throw new Error(error.message);
  }
};
